import { proxy } from "valtio";
import type { HomeState } from "../types";

export const HomeStore = proxy<HomeState>({
  type: "stock",
  isOpen: true,
  activeTab: undefined,
  investMovesEdFlaggedExpanded: false,
});
